/**
 * Parse cell value: "时间,指标;2025,100;2026,200;"
 * Semicolon-separated rows, comma-separated columns.
 * Returns header + column-oriented data for template:
 *   const [categoryLabel, seriesLabel] = header;
 *   const [category, series1] = data;
 */
export interface TableCellChartData {
  header: string[];
  data: (string | number)[][];
}

export function parseTableCellChartData(raw: unknown): TableCellChartData | null {
  if (raw === null || raw === undefined) {
    return null;
  }

  const matrix = String(raw)
    .split(';')
    .map(row => row.trim())
    .filter(Boolean)
    .map(row => row.split(',').map(cell => cell.trim()));

  if (matrix.length < 2 || matrix[0].length < 2) {
    return null;
  }

  const header = matrix[0];
  const dataRows = matrix.slice(1);

  const columnCount = header.length;
  const columns: (string | number)[][] = [];

  for (let colIndex = 0; colIndex < columnCount; colIndex++) {
    if (colIndex === 0) {
      columns.push(dataRows.map(row => row[0] ?? ''));
      continue;
    }

    const series: number[] = [];
    for (const row of dataRows) {
      if (row.length < columnCount) {
        return null;
      }
      const value = Number(row[colIndex]);
      if (Number.isNaN(value)) {
        return null;
      }
      series.push(value);
    }
    columns.push(series);
  }

  return { header, data: columns };
}
